import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { CancelationReason } from 'contracts/CancelationReasons';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_CANCELATION_REASON_',
  }
);

export interface FetchCancelationReasonState {
  data: CancelationReason | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchCancelationReasonRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: CancelationReason;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchCancelationReasonState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchCancelationReasonState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchCancelationReasonState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchCancelationReasonState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchCancelationReasonState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchCancelationReason = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchCancelationReasonTypes = Types;
export const FetchCancelationReasonActions = Creators;
